import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { SLARoutesApplication } from '../../constants';

function setupSla(): void {
  applicationModuleRegistry.register({
    closeable: true,
    id: 'sla-file-list',
    entry: 'sla-file-list',
    name: 'modules.sla',
    route: SLARoutesApplication.SLA,
  });
}

export {
  setupSla,
};
